import React, {useEffect, useState} from "react"
import Tableau from "../../components/Tableau/Tableau"
import {apiFetchTableauTicket} from "../../actions/storyboardApi";
import "../../components/Tableau/tableau-2.9.0.min.js"
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {fetchWorkbooks, selectWorkbook, selectWorkbooks, setWorkbook} from "./storyboardSlice";
import _ from "lodash";

export const VIZ_ELEMENT_ID = "tableauViz"

const Storyboard = () => {

    const dispatch = useAppDispatch()
    const workbooks = useAppSelector(selectWorkbooks)
    const workbook = useAppSelector(selectWorkbook)

    const {workbookId} = useParams()

    useEffect(() => {
        if (_.isUndefined(workbooks)) {
            dispatch(fetchWorkbooks())
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (workbooks && workbooks.length > 0) {
            if (workbookId) {
                const workbook = _.find(workbooks, {workbookId: workbookId})
                if (workbook) {
                    dispatch(setWorkbook(workbook))
                }
            } else if (!workbook){
                dispatch(setWorkbook(workbooks[0]))
            }
        }
    })

    const [height, setHeight] = useState<string | undefined>(undefined)

    const [ticket, setTicket] = useState<string | null>(null)
    useEffect(() => {
        // TODO: could improve performance by checking first if auth has already been done by looking at cookie or setting a state
        apiFetchTableauTicket().then((ticket) => setTicket(ticket))
    }, []);

    const [ready, setReady] = useState(false)
    useEffect(() => {
        // Once the component has loaded, we are ready to load our viz.
        if (workbook && ticket) {
            const element = document.getElementById(VIZ_ELEMENT_ID)!
            const rect = element.getBoundingClientRect()
            setHeight((window.innerHeight - rect.top) + "px")
            setReady(true)
        }
    }, [workbook, ticket])

    return (
        <div id={VIZ_ELEMENT_ID} data-testid={`${VIZ_ELEMENT_ID}-${workbook?.workbookId}`}>
            {ready ?
                // If ready, load the viz
                <Tableau
                    parentElement={document.getElementById(VIZ_ELEMENT_ID)!}
                    dashboardURL={workbook!.viewURL!}
                    ticket={ticket!}
                    vizOptions={{
                        hideTabs: true,
                        hideToolbar: false,
                        width: '100%',
                        height: height
                    }}
                /> :
                // Otherwise, return nothing
                null
            }
        </div>
    )

}

export default Storyboard